import { AccountApi } from './common/api/account-api';
import { ActivityApi } from './common/api/activity-api';
import { AttributesApi } from './common/api/attributes-api';
import { SearchQualityApi } from './common/api/search-quality-api';
import { BonusSettlementsApi } from './features/bonus-settlements/api/bonus-settlements-api';
import { CategoryApi } from './common/api/category-api';
import { ClassificationsApi } from './common/api/classifications-api';
import { CommonApi } from './common/api/api';
import { ContactApi } from './common/api/contact-api';
import { ContactsAndOrganizationsApi } from './features/contacts-and-organizations/api/contacts-and-organizations-api';
import { ContentManagementApi } from './features/content-management/api/content-management-api';
import { CustomerApi } from './common/api/customer-api';
import { DashboardApi } from './features/dashboard/dashboard-api';
import { DemandApi } from './features/demands/demand-api';
import { EclassApi } from './common/api/eclass-api';
import { ImportApi } from './features/products/import/api/import-api';
import { InquiryApi } from './features/inquiries/inquiry-api';
import { InternalNotesApi } from './common/api/internal-notes-api';
import { InvoiceApi } from './features/invoices/invoice-api';
import { InvoiceNumberSequenceApi } from './common/api/invoice-number-sequence-api';
import { OfferApi } from './common/api/offer-api';
import { OmniSearchApi } from './common/api/omni-search-api';
import { PaymentTermsApi } from './common/api/payment-terms-api';
import { PositionsApi } from './common/api/positions-api';
import { ProductApi } from './features/products/product/api/product-api';
import { ProductSearchApi } from './features/products/product/product-detail/variants/api/product-search-api';
import { PurchaseOrderApi } from './features/purchase-orders/purchase-order-api';
import { ReceiptAlertApi } from './common/api/receipt-alert-api';
import { SalesOrdersApi } from './features/sales-orders/sales-order-api';
import { SupplierApi } from './common/api/supplier-api';
import { TagApi } from './common/api/tag-api';
import { TaxRatesApi } from './common/api/tax-rate-api';
import { TopicsApi } from './common/api/topics-api';
import { TransitionActivitiesApi } from './common/api/transition-activities-api';
import { TransitionsApi } from './features/convert-receipt/transition-api';
import { UnitApi } from './common/api/unit-api';

export class Api {
    constructor(private baseUrl: string) {}

    public common: CommonApi = new CommonApi(this.baseUrl);
    public activities: ActivityApi = new ActivityApi(this.baseUrl);
    public omniSearch: OmniSearchApi = new OmniSearchApi(this.baseUrl);
    public accounts: AccountApi = new AccountApi(this.baseUrl);
    public categories: CategoryApi = new CategoryApi(this.baseUrl);
    public attributes: AttributesApi = new AttributesApi(this.baseUrl);
    public searchQuality: SearchQualityApi = new SearchQualityApi(this.baseUrl);
    public contact: ContactApi = new ContactApi(this.baseUrl);
    public customer: CustomerApi = new CustomerApi(this.baseUrl);
    public demands: DemandApi = new DemandApi(this.baseUrl);
    public inquiries: InquiryApi = new InquiryApi(this.baseUrl);
    public invoices: InvoiceApi = new InvoiceApi(this.baseUrl);
    public offer: OfferApi = new OfferApi(this.baseUrl);
    public productSearch: ProductSearchApi = new ProductSearchApi(this.baseUrl);
    public product: ProductApi = new ProductApi(this.baseUrl);
    public supplier: SupplierApi = new SupplierApi(this.baseUrl);
    public unit: UnitApi = new UnitApi(this.baseUrl);
    public transitions: TransitionsApi = new TransitionsApi(this.baseUrl);
    public transitionActivities: TransitionActivitiesApi = new TransitionActivitiesApi(this.baseUrl);
    public tag: TagApi = new TagApi(this.baseUrl);
    public purchaseOrders: PurchaseOrderApi = new PurchaseOrderApi(this.baseUrl);
    public salesOrders: SalesOrdersApi = new SalesOrdersApi(this.baseUrl);
    public dashboard: DashboardApi = new DashboardApi(this.baseUrl);
    public import: ImportApi = new ImportApi(this.baseUrl);
    public contactsAndOrganizations: ContactsAndOrganizationsApi = new ContactsAndOrganizationsApi(this.baseUrl);
    public contentManagement: ContentManagementApi = new ContentManagementApi(this.baseUrl);
    public eclass: EclassApi = new EclassApi(this.baseUrl);
    public positions: PositionsApi = new PositionsApi(this.baseUrl);
    public taxRates: TaxRatesApi = new TaxRatesApi(this.baseUrl);
    public invoiceNumberSequences: InvoiceNumberSequenceApi = new InvoiceNumberSequenceApi(this.baseUrl);
    public receiptAlert: ReceiptAlertApi = new ReceiptAlertApi(this.baseUrl);
    public paymentTerms: PaymentTermsApi = new PaymentTermsApi(this.baseUrl);
    public classifications: ClassificationsApi = new ClassificationsApi(this.baseUrl);
    public topics: TopicsApi = new TopicsApi(this.baseUrl);
    public internalNotes: InternalNotesApi = new InternalNotesApi(this.baseUrl);
    public bonusSettlements: BonusSettlementsApi = new BonusSettlementsApi(this.baseUrl);
}
